import './App.css';
import Header from './conponents/Header';

function App() {
  return (
    <>
    <div>
     <Header/>
      
    </div>

    </>
  );
}

export default App;
